import { Col, Row } from 'antd';
import DropdownInput from 'components/dropdown/dropDownInput';
import FileUploadInput from 'components/fileUpload/fileUploadInput';
import { useTranslate } from '@refinedev/core';
import fileTypesMapping from 'pages/rules/fileTypesMapping';
import { useWatch } from 'antd/es/form/Form';
import apiEndpoint from 'core/common/apiEndPoints';

import { useEffect, useState } from 'react';
import DmnGenerator from 'components/modules/dmn/src/App';
import classNames from 'core/utils/classNames';
import RadioInput from 'components/radio/RadioInput';
import { useRulesCreateState } from 'pages/rules/context/RulesCreateStateContext';
import usePermission from 'core/utils/usePermission';
import PrivateRouteConst from 'core/common/privateRouteConstant';

// eslint-disable-next-line import/extensions
import useRulesDropdown from './RulesDropdown';

const DMNViewer = ({
  defaultFileListObj,
  form,
  fileType,
  message,
  type,
  clawbackType,
}) => {
  const state = useRulesCreateState();
  const {
    selectedFileType,
    xmlStructure,
    concatList,
    ruleData,
    allowEdit,
    dmnData,
    validationErrors,
    setInputSourceFileData,
    setXmlStructure,
    setHasInvalidOutputColumn,
    setHasInvalidInputColumn,
    setDmnErrors,
    setIsDmnValid,
    setDmnData,
    setSelectedFileType,
  } = state;

  const [isReset, setIsReset] = useState(false);
  const t = useTranslate();
  const { uploadOptions } = useRulesDropdown();
  const uploadType = useWatch('file_upload_type', {
    form,
    preserve: true,
  });
  const ruleFileType = useWatch('rule_file_type', {
    form,
    preserve: true,
  });

  const checkPermission = usePermission();
  const hasGridView = checkPermission(PrivateRouteConst.GRID_VIEW);
  const hasGridEdit = checkPermission(PrivateRouteConst.GRID_EDIT);
  const hasGridAddColumn = checkPermission(PrivateRouteConst.GRID_ADD_COLUMN);
  const hasGridAddRow = checkPermission(PrivateRouteConst.GRID_ADD_ROW);
  const hasShowGridFilter = checkPermission(PrivateRouteConst.SHOW_GRID_FILTER);
  const version = form.getFieldValue('rule_version');

  useEffect(() => {
    if (ruleData !== undefined && (allowEdit || type === 'Show') && version) {
      const data = ruleData.filter((item) => item?.rule_version === version)[0];
      console.log(data);
    }
  }, [ruleData, version]);

  const handleReset = () => {
    setXmlStructure('');
    setDmnData({
      data: [],
      inputFields: [],
      outputFields: [],
    });
    setIsReset(!isReset);
  };

  const isFileDataEmpty = !state.inputSourceFileData;
  const { hasInvalidInputColumn, hasInvalidOutputColumn } = state;

  console.log(clawbackType, 'clawbackType');
  //   const ruleType = form.getFieldValue('rule_type');
  // const showReset = ruleType !== 'custom';

  return (
    <>
      <Row gutter={16} justify="space-between">
        {type === 'Create' ? (
          <div className="hidden">
            <Col xs={24} sm={24} lg={8}>
              <DropdownInput
                label={t('rules.ruleFileType')}
                name="rule_file_type"
                required={true}
                optionList={fileType}
                disabled={allowEdit || type === 'Show'}
                message={t('rules.messages.ruleFileType')}
                placeholder={t('rules.messages.ruleFileType')}
                onChange={(e) => {
                  setSelectedFileType(e);
                }}
              />
            </Col>
          </div>
        ) : null}
        {ruleFileType === 'dmn' && type !== 'Show' && xmlStructure === '' ? (
          <Col xs={24} sm={24} lg={10}>
            <RadioInput
              label="Select Upload Type"
              name="file_upload_type"
              options={uploadOptions}
            />
          </Col>
        ) : null}
      </Row>

      <>
        {(ruleFileType === 'dmn' &&
          xmlStructure === '' &&
          uploadType === 'upload_file' &&
          type !== 'Show') ||
        (ruleFileType !== 'dmn' && type === 'Create') ? (
          <Row gutter={16} className="mb-4">
            <Col xs={24} sm={24} lg={24}>
              <FileUploadInput
                projectFileType="rule"
                selectFile={selectedFileType}
                fileUploadEndpoint={apiEndpoint.fileUpload}
                name="rule_file_path"
                message={t('pages.fileUploadTxts.message')}
                required={defaultFileListObj?.length === 0}
                fileType={
                  fileTypesMapping[selectedFileType] || fileTypesMapping.Default
                }
                disabled={type === 'Show' || ruleFileType === undefined}
                setInputSourceFileData={setInputSourceFileData}
                defaultFileList={[]}
                fileTypeSource="rules"
                form={form}
                setXmlStructure={setXmlStructure}
                setHasInvalidOutputColumn={setHasInvalidOutputColumn}
                setHasInvalidInputColumn={setHasInvalidInputColumn}
                setDmnErrors={setDmnErrors}
                setIsDmnValid={setIsDmnValid}
              />
            </Col>
          </Row>
        ) : null}
        <div id="scrollDmn">
          {ruleFileType === 'dmn' &&
          uploadType !== undefined &&
          !(uploadType === 'upload_file' && xmlStructure === '') ? (
            <div key={isReset.toString()}>
              <DmnGenerator
                type={type}
                xmlStructure={xmlStructure}
                setXmlStructure={setXmlStructure}
                handleReset={handleReset}
                dmnData={dmnData}
                setDmnData={setDmnData}
                validationErrors={validationErrors}
                hasGridView={hasGridView}
                hasGridEdit={hasGridEdit}
                hasGridAddColumn={hasGridAddColumn}
                hasGridAddRow={hasGridAddRow}
                hasShowGridFilter={hasShowGridFilter}
                // showReset={showReset}
                concatList={
                  clawbackType === 'PARTIAL'
                    ? [{ name: 'Time_Since_Contract', type: 'double' }]
                    : concatList.map((item) => ({
                        name: item?.label,
                        type:
                          item?.data_type === 'number' ||
                          item?.data_type === 'decimal'
                            ? 'double'
                            : 'string',
                      }))
                }
              />
            </div>
          ) : null}
        </div>
        {message ? (
          <div className="rule-config-card">
            <div
              className={classNames(
                'text-lg text-center font-semibold',
                hasInvalidOutputColumn ||
                  hasInvalidInputColumn ||
                  isFileDataEmpty
                  ? 'text-red-500'
                  : 'text-black'
              )}
            >
              {message}
            </div>
          </div>
        ) : null}
      </>
    </>
  );
};

export default DMNViewer;
